import { ITheme } from '@uifabric/styling';
import RequestStatus from '../store/schema/RequestStatus';
import { getFooterItemProps, getHeaderItemProps } from './getHeaderFooterProps';
import { IBaseFloatingPickerSuggestionProps } from 'office-ui-fabric-react/lib/FloatingPicker';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

export default function getSuggestionProps(
    queryString: string,
    findLocationRequestStatus: RequestStatus,
    numOfSuggestions: number,
    theme?: ITheme,
    colorScheme?: ColorScheme,
    disableUseThisLocationButton?: boolean
): IBaseFloatingPickerSuggestionProps {
    return {
        headerItemsProps: getHeaderItemProps(
            queryString,
            numOfSuggestions,
            colorScheme,
            disableUseThisLocationButton
        ),

        footerItemsProps: getFooterItemProps(
            queryString,
            findLocationRequestStatus,
            numOfSuggestions,
            theme
        ),
        shouldSelectFirstItem: () => {
            return false;
        },
    };
}
